// QA PO-8: a profile now opens in place, so Back has to land on the list as it was left: the same
// filters, page and scroll position. Kept for this tab only.
const KEY = "tnListState";

export interface TalentListState {
  roles: string[];
  tools: string[];
  languages: string[];
  page: number;
  perPage: number;
  scrollY: number;
}

const strings = (v: unknown) => (Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : []);
const positive = (v: unknown, fallback: number) => (typeof v === "number" && v > 0 ? v : fallback);

export function loadListState(): TalentListState | null {
  try {
    const s = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (!s || typeof s !== "object") return null;
    return {
      roles: strings(s.roles),
      tools: strings(s.tools),
      languages: strings(s.languages),
      page: positive(s.page, 1),
      perPage: positive(s.perPage, 5),
      scrollY: typeof s.scrollY === "number" && s.scrollY > 0 ? s.scrollY : 0,
    };
  } catch {
    return null;
  }
}

export function saveListState(state: TalentListState): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // storage unavailable: Back shows the list from the top
  }
}
